'use client';

import React from 'react';
import Header from 'components/commercetools-ui/organisms/header';
import { HeaderProps } from 'components/commercetools-ui/organisms/header/types';

import { TasticProps } from '../types';

const HeaderTastic = ({ data }: TasticProps<HeaderProps>) => {
  return <Header dataSource={{ dataSource: data.dataSource.dataSource }} />;
};
export default HeaderTastic;
